import React from 'react';
import {
    FormattableServerMessage,
    serverErrorMessages,
} from '@99designs/apps/spa/pages/auth/SSO/common/serverErrorMessages';
import { Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';

export function CreateAccountErrorMessage({
    errorCode,
    onRetry,
}: {
    errorCode: string;
    onRetry: () => void;
}) {
    const createAccountErrorMessages: Record<string, FormattableServerMessage> = {
        ...serverErrorMessages,
        'user-logged-in': {
            message: __(
                'It looks like you already have a 99designs account. Continue with your existing account.'
            ),
        },
        'oauth-signup-error': {
            message: __('Sign up failed. Please contact support for assistance.'),
        },
        'oauth-error': {
            message: __('Signup failed. <Link>Try again.</Link>'),
            values: {
                Link: <Link onClick={onRetry} color="white" />,
            },
        },
        'user-already-exists': {
            message: __('Sign up failed. Please log in If you have an existing 99designs account.'),
        },
    };

    const message = createAccountErrorMessages[errorCode]?.message || errorCode;
    const replacements = createAccountErrorMessages[errorCode]?.values || {};

    return <FormattedReactMessage message={message} replacements={replacements} />;
}
